import React, { useRef, useEffect, useState } from "react";
import Calendar from "../../components/calendar";
import {
  mapAppointmentDetails,
  enhanceAndSortAppointmentDetails,
  getCurrentMonthDates,
  parseDateString,
  getStartAndEndDate,
  getTodayDate,
} from "../../components/calendar/helper";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Divider,
  Flex,
  Image,
  Spacer,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import SearchBar from "../../components/search-bar";
import TabSection from "../../components/tabs";
import PrimaryButton from "../../components/primary-button";
import PrimaryButtonIcon from "../../components/primary-button-icon";
import { COLORS } from "../../components/styles/colors";
import { getPatientAppointmentListForDoctor } from "../../middleware/services/visits";
import PatientVisitCard from "../../components/patient-visit-card";
import Loader from "../../components/loader/loader";
import useLoader from "../../components/loader/loaderstates";
import { useScreenType } from "../../auth";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";

const VisitsIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedIndicator, setSelectedIndicator] = useState("all")
  const handleTabClick = (index) => {
    setSelectedTabIndex(index);
  };
  
  // To be used by side bar
  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [pastAppointments, setPastAppointments] = useState([]);
  const [completedAppointments, setCompletedAppointments] = useState([]);
  const [totalUpcomingAppointments, setTotalUpcomingAppointments] = useState(
    []
  );
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [appointmentCounts, setAppointmentCounts] = useState({
    all: 0,
    upcoming: 0,
    completed: 0,
    pending: 0,
    "no-show": 0,
    cancelled: 0,
  });


  // console.log("Start Date:", formattedStartDate);
  // console.log("End Date:", formattedEndDate);

  const [formattedStartDate, formattedEndDate] = getTodayDate(); // format of YYYY-MM-DD
  // to be used by calendar
  const [calendarAppointments, setCalendarAppointments] = useState([]);
  const [calendarStartDate, setCalendarStartDate] =
    useState(formattedStartDate);
  const [calendarEndDate, setCalendarEndDate] = useState(formattedEndDate);
  const screenType = useScreenType();
  const handleCalendarTitleChange = (title) => {
    // console.log(title);
    // console.log(parseDateString(title));
    const { calendarStart, calendarEnd } = getStartAndEndDate(title);

    // Update state for calendar start date
    setCalendarStartDate(calendarStart);

    // Update state for calendar end date
    setCalendarEndDate(calendarEnd);
  };

  // for calendar
  const fetchCalendarData = async (start, end) => {
    // console.log("Calendar Data Fetched");
    // console.log(start, end);
    showLoader();
    try {
      const upcomingCalendarResult = await getPatientAppointmentListForDoctor({
        appointmentstatus: 3,
        startdate: start,
        enddate: end,
      });

      // const pastCalendarResult = await getPatientAppointmentListForDoctor({
      //   appointmentstatus: 2,
      //   startdate: start,
      //   enddate: end,
      // });

      const combinedAppointments = mapAppointmentDetails([
        ...(upcomingCalendarResult || []),
        //...(pastCalendarResult || []),
      ]);

      setCalendarAppointments(combinedAppointments);
    } catch (error) {
      console.error("Error fetching calendar data:", error);
    } finally {
      dismissLoader();
    }
  };

  const fetchSidePanelData = async (start, end) => {
    // console.log("Side Panel Data Fetched");
    showLoader();
    try {
      const upcomingResult = await getPatientAppointmentListForDoctor({
        appointmentstatus: 3,
        startdate: start,
        enddate: end,
      });
      setUpcomingAppointments(upcomingResult || []);

      // const pastResult = await getPatientAppointmentListForDoctor({
      //   appointmentstatus: 2,
      //   startdate: start,
      //   enddate: end,
      // });
      // setPastAppointments(pastResult || []);
    } catch (error) {
      console.error("Error fetching side panel data:", error);
    } finally {
      dismissLoader();
    }
  };

  useEffect(() => {
    fetchCalendarData(calendarStartDate, calendarEndDate);
  }, [calendarStartDate, calendarEndDate]);

  useEffect(() => {
    fetchSidePanelData(calendarStartDate, calendarEndDate);
  }, [calendarStartDate, calendarEndDate]);

  const refreshPageContent = () => {
    fetchCalendarData(calendarStartDate, calendarEndDate);
    fetchSidePanelData(calendarStartDate, calendarEndDate);
  };

  // useEffect(() => {
  //   // Check if cancelledAppointments array is empty
  //   if (pastAppointments.length === 0) {
  //     setTotalUpcomingAppointments(upcomingAppointments);
  //   } else {
  //     const combinedAppointments = upcomingAppointments.concat(
  //       pastAppointments
  //     );
  //     setTotalUpcomingAppointments(combinedAppointments);
  //   }
  // }, [upcomingAppointments, pastAppointments]);

  const filterByIndicator = (appointments) => {
    if (selectedIndicator == "all") return appointments;
    // console.log(appointments, 'check appo')
    // console.log(appointments.appointmentstatus, 'check appo')
    return appointments.filter(
      (appointment) => appointment.appointmentstatusname?.toLowerCase() === selectedIndicator
    );

  };

    useEffect(() => {
    const counts = {
      all: 0,
      upcoming: 0,
      completed: 0,
      pending: 0,
      "no-show": 0,
      cancelled: 0,
    };

    upcomingAppointments.forEach((appointment) => {
      counts.all++; // Count for 'All'
      const statusName = appointment.appointmentstatusname?.toLowerCase();
      if (counts[statusName] !== undefined) {
        counts[statusName]++;
      }
    });
    setAppointmentCounts(counts);
  }, [upcomingAppointments]);


  const statuses = [
    { id: "all", label: "All", bgColor: "#000", length: appointmentCounts.all },
    { id: "upcoming", label: "Upcoming", bgColor: "#10b981", length: appointmentCounts.upcoming },
    { id: "completed", label: "Completed", bgColor: "#3182ce", length: appointmentCounts.completed },
    { id: "pending", label: "Pending", bgColor: "#d69e2e", length: appointmentCounts.pending },
    { id: "no-show", label: "No-show", bgColor: "#e53e3e", length: appointmentCounts["no-show"] },
    { id: "cancelled", label: "Cancelled", bgColor: "#718096", length: appointmentCounts.cancelled },
  ]

  return (
    <>
      {isLoading && <Loader />}
      {screenType == "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            <Box w="100%">
              <SecondaryNav customHeader="Visits" />

              {/* Main container start */}
              <Flex w="calc(100vw - 6rem)">
                <Box
                  // p="1.5rem 8.25rem"
                  display="flex"
                  h="calc(100vh - 4rem)"
                  // h="100vh"
                  overflow="hidden auto"
                  overflowY={"hidden"}
                  w="100%"
                >
                  {/* Left area start */}

                  <Box
                    w="23rem"
                    h="calc(100vh - 6rem)"
                    borderRight="1px solid #E6E7E9"
                  >
                    <Box p="1.5rem" pb='0' pt={showSearch ? "1.5rem" : "10px"} display="flex" flexDir="column" gap="6px ">
                    {showSearch && 
                      <SearchBar
                        passInputPlace="Search"
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    }
                      {/* <TabSection
                        tabs={["Upcoming", "Past"]}
                        onClickTab={handleTabClick}
                        defaultIndex={selectedTabIndex}
                      /> */}
                      <Flex
                        direction="row"
                        wrap="wrap"
                        gap={3}
                        p="10px 0"
                        // bg="gray.100"
                        borderRadius="md"
                        maxWidth="xs"
                        flexWrap='nowrap'
                        alignItems='center'
                        data-testid={selectedIndicator}
                      >
                        <Box display='flex' flexWrap='wrap' alignItems='center' gap={2}>
                          {statuses.map((item)=> (
                            <Box as="label" key={item.id} 
                              p={selectedIndicator === item.id ? "2px 5px" : ""} 
                              // borderColor={selectedIndicator === item.id ? item.bgColor : ""}
                              border={selectedIndicator === item.id ? `1px solid ${item.bgColor}` : ''}
                              borderRadius='5px'
                              pos='relative'>
                              <Box 
                                as="span" 
                                color='white' 
                                bg={selectedIndicator !== item.id ? "transparent" : item.bgColor}
                                p='1px 4px'
                                borderRadius='full'
                                fontSize='9px'
                                fontWeight='700'
                                pos='absolute'
                                top='-12px'
                                right='-5px'
                              >{item.length}</Box>
                              <Box display='flex' pos='relative' alignItems='center' cursor='pointer'>
                                <input
                                  type="radio"
                                  name="status"
                                  value={item.id}
                                  checked={selectedIndicator === item.id}
                                  onChange={() => setSelectedIndicator(item.id)}
                                  className="sr-only"
                                  style={{display: 'none'}}
                                />
                                <Box
                                  w={3} h={3} borderRadius='full' mr={2} border={'3px solid'} 
                                  bg={selectedIndicator === item.id ? "transparent" : item.bgColor}
                                  borderColor={selectedIndicator === item.id ? item.bgColor : "transparent"}
                                  // boxShadow={selectedIndicator === item.id ? `0 0 0 2px rgba(139, 139, 139, 0.5)` : `none`}
                                ></Box>
                                <Box as="span" fontSize="xs" fontWeight={selectedIndicator === item.id ? "700" : ""}>
                                  {item.label}
                                </Box>
                              </Box>
                            </Box>
                            ))}
                        </Box>
                        {!showSearch && 
                        <Box p='0.5rem' cursor='pointer' onClick={()=> setShowSearch(true)} border='1px solid #e2e2e2' borderRadius='md'>
                          <Image w='2rem' src="/assets/imgs/search.png"/>
                        </Box>
                        }
                      </Flex>
                    </Box>

                    <Box
                      bg="#f9f9fa"
                      h={showSearch ? "calc(100vh - 14rem)" : "calc(100vh - 9rem)"}
                      overflow="hidden auto"
                      p="1.5rem"
                    >
                      {/* {selectedTabIndex === 0 && ( */}
                        <Box>
                          {enhanceAndSortAppointmentDetails(
                            upcomingAppointments
                          ).some((appointment) => appointment.today) && (
                            <Box>
                              {/* <Text
                                fontSize="0.75rem"
                                mb="1rem"
                                letterSpacing="0.1rem"
                                fontWeight="600"
                                textTransform="uppercase"
                                color="#061027"
                              >
                                Today
                              </Text> */}
                              {/* Render patient cards for today */}
                              <Box display="flex" flexDir="column" gap="1rem">
                                {enhanceAndSortAppointmentDetails(
                                  filterByIndicator(upcomingAppointments)
                                )
                                  .filter((appointment) => appointment.today)
                                  .filter((appointment) =>
                                    appointment.patientname
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                  ).length === 0 && search.trim() !== "" ? (
                                  <Box textAlign="center" padding="1rem">
                                    No appointments available
                                  </Box>
                                ) : (
                                  enhanceAndSortAppointmentDetails(
                                    filterByIndicator(upcomingAppointments)
                                  )
                                    .filter((appointment) => appointment.today)
                                    .filter((appointment) =>
                                      appointment.patientname
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                    )
                                    .map((appointment) => (
                                      <PatientVisitCard
                                        key={appointment.appointmentid}
                                        userImage={
                                          appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                        }
                                        // userImage={
                                        //   appointment.imagepath &&
                                        //   appointment.patientimage
                                        //     ? appointment.imagepath +
                                        //       appointment.patientimage
                                        //     : null
                                        // }
                                        isUpcoming={true}
                                        userName={appointment.patientname}
                                        visitDate={appointment.visitDate}
                                        visitTime={appointment.visitTime}
                                        doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                        issue={appointment.chiefcomplaint}
                                        borderColor={appointment.color}
                                        bgColor={appointment.color}
                                        patientId={appointment.patientid}
                                        refreshPageContent={refreshPageContent}
                                        appointmentId={
                                          appointment.appointmentid
                                        }
                                        appointmentStatus={
                                          appointment.appointmentstatus
                                        }
                                        visitStatus={
                                          appointment.appointmentcurrentstatus
                                        }
                                        statusName={
                                          appointment.appointmentstatusname
                                        }
                                        isAssign={appointment.isaasign}
                                        isAssignStatus={appointment.assignstatusname}
                                        prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                      />
                                    ))
                                )}
                              </Box>
                            </Box>
                          )}
                          {enhanceAndSortAppointmentDetails(
                            filterByIndicator(upcomingAppointments)
                          ).some((appointment) => appointment.tomorrow) && (
                            <Box>
                              {/* <Text
                                fontSize="0.75rem"
                                my="1rem"
                                letterSpacing="0.1rem"
                                fontWeight="600"
                                textTransform="uppercase"
                                color="#061027"
                              >
                                Tomorrow
                              </Text> */}
                              {/* Render patient cards for tomorrow */}
                              <Box display="flex" flexDir="column" gap="1rem">
                                {enhanceAndSortAppointmentDetails(
                                  filterByIndicator(upcomingAppointments)
                                )
                                  .filter((appointment) => appointment.tomorrow)
                                  .filter((appointment) =>
                                    appointment.patientname
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                  ).length === 0 && search.trim() !== "" ? (
                                  <Box textAlign="center" padding="1rem">
                                    No appointments available
                                  </Box>
                                ) : (
                                  enhanceAndSortAppointmentDetails(
                                    filterByIndicator(upcomingAppointments)
                                  )
                                    .filter(
                                      (appointment) => appointment.tomorrow
                                    )
                                    .filter((appointment) =>
                                      appointment.patientname
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                    )
                                    .map((appointment) => (
                                      <PatientVisitCard
                                        key={appointment.appointmentid}
                                        // userImage={
                                        //   appointment.imagepath &&
                                        //   appointment.patientimage
                                        //     ? appointment.imagepath +
                                        //       appointment.patientimage
                                        //     : null
                                        // }
                                        userImage={
                                          appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                        }
                                        userName={appointment.patientname}
                                        visitDate={appointment.visitDate}
                                        visitTime={appointment.visitTime}
                                        doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                        issue={appointment.chiefcomplaint}
                                        borderColor={appointment.color}
                                        bgColor={appointment.color}
                                        appointmentId={
                                          appointment.appointmentid
                                        }
                                        patientId={appointment.patientid}
                                        refreshPageContent={refreshPageContent}
                                        appointmentStatus={
                                          appointment.appointmentstatus
                                        }
                                        visitStatus={
                                          appointment.appointmentcurrentstatus
                                        }
                                        statusName={
                                          appointment.appointmentstatusname
                                        }
                                        isAssign={appointment.isaasign}
                                        isAssignStatus={appointment.assignstatusname}
                                        prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                      />
                                    ))
                                )}
                              </Box>
                            </Box>
                          )}
                          {/* Render patient cards for this month */}
                          <Box>
                            {/* <Text
                              fontSize="0.75rem"
                              my="1rem"
                              letterSpacing="0.1rem"
                              fontWeight="600"
                              textTransform="uppercase"
                              color="#061027"
                            >
                              This Month
                            </Text> */}
                            <Box display="flex" flexDir="column" mb='0.75rem' gap="1rem">
                              {enhanceAndSortAppointmentDetails(
                                filterByIndicator(upcomingAppointments)
                              )
                                .filter(
                                  (appointment) =>
                                    !appointment.today && !appointment.tomorrow
                                )
                                .filter((appointment) =>
                                  appointment.patientname
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                                ).length === 0 && search.trim() !== "" ? (
                                <Box textAlign="center" padding="1rem">
                                  No appointments available
                                </Box>
                              ) : (
                                enhanceAndSortAppointmentDetails(
                                  filterByIndicator(upcomingAppointments)
                                )
                                  .filter(
                                    (appointment) =>
                                      !appointment.today &&
                                      !appointment.tomorrow
                                  )
                                  .filter((appointment) =>
                                    appointment.patientname
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                  )
                                  .map((appointment) => (
                                    <PatientVisitCard
                                      key={appointment.appointmentid}
                                      // userImage={
                                      //   appointment.imagepath &&
                                      //   appointment.patientimage
                                      //     ? appointment.imagepath +
                                      //       appointment.patientimage
                                      //     : null
                                      // }
                                      userImage={
                                        appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                      }
                                      userName={appointment.patientname}
                                      visitDate={appointment.visitDate}
                                      visitTime={appointment.visitTime}
                                      doctorName={appointment.doctorname}
                                      patientFcm={appointment.fcmtoken}
                                      issue={appointment.chiefcomplaint}
                                      borderColor={appointment.color}
                                      bgColor={appointment.color}
                                      appointmentId={appointment.appointmentid}
                                      patientId={appointment.patientid}
                                      refreshPageContent={refreshPageContent}
                                      appointmentStatus={
                                        appointment.appointmentstatus
                                      }
                                      visitStatus={
                                        appointment.appointmentcurrentstatus
                                      }
                                      statusName={
                                        appointment.appointmentstatusname
                                      }
                                      isAssign={appointment.isaasign}
                                      isAssignStatus={appointment.assignstatusname}
                                      prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                    />
                                  ))
                              )}
                            </Box>
                          </Box>
                        </Box>
                      {/* )} */}

                      {/* Render content for the "Completed" tab */}
                      {/* {selectedTabIndex === 1 && ( */}
                        <Box>
                          <Box>
                            {/* <Text
                            fontSize="0.75rem"
                            mb="1rem"
                            letterSpacing="0.1rem"
                            fontWeight="600"
                            textTransform="uppercase"
                            color="#061027"
                          >
                            Completed
                          </Text> */}
                            {/* Render completed patient cards */}
                            <Box display="flex" flexDir="column" gap="1rem">
                              {enhanceAndSortAppointmentDetails(
                                pastAppointments,
                                true
                              ) // reverse sort
                                .filter((appointment) =>
                                  appointment.patientname
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                                ).length === 0 && search.trim() !== "" ? (
                                <Box textAlign="center" padding="1rem">
                                  No appointments available
                                </Box>
                              ) : (
                                enhanceAndSortAppointmentDetails(
                                  pastAppointments,
                                  true
                                ) // reverse sort
                                  .filter((appointment) =>
                                    appointment.patientname
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                  )
                                  .map((appointment) => (
                                    <PatientVisitCard
                                      key={appointment.appointmentid}
                                      userImage={
                                        appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                      }
                                      userName={appointment.patientname}
                                      visitDate={appointment.visitDate}
                                      visitTime={appointment.visitTime}
                                      doctorName={appointment.doctorname}
                                      patientFcm={appointment.fcmtoken}
                                      issue={appointment.chiefcomplaint}
                                      borderColor={appointment.color}
                                      bgColor={appointment.color}
                                      appointmentId={appointment.appointmentid}
                                      patientId={appointment.patientid}
                                      // fetchCalendarData={fetchCalendarData}
                                      // fetchSidePanelData={fetchSidePanelData}
                                      refreshPageContent={refreshPageContent}
                                      appointmentStatus={
                                        appointment.appointmentstatus
                                      }
                                      visitStatus={
                                        appointment.appointmentcurrentstatus
                                      }
                                      statusName={
                                        appointment.appointmentstatusname
                                      }
                                      isAssign={appointment.isaasign}
                                      isAssignStatus={appointment.assignstatusname}
                                      prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                    />
                                  ))
                              )}
                            </Box>
                          </Box>
                        </Box>
                      {/* )} */}
                    </Box>
                  </Box>

                  {/* Left area end */}

                  {/* Main container start */}

                  <Box w="85%" bg="#ffffff" pb="0" overflowX="auto">
                    <Calendar
                      eventsArray={calendarAppointments}
                      setCalendarStartDate={setCalendarStartDate}
                      setCalendarEndDate={setCalendarEndDate}
                      onCalendarTitleChange={handleCalendarTitleChange}
                      refreshPageContent={refreshPageContent}
                    />
                  </Box>
                  {/* Main container end */}
                </Box>
              </Flex>
              {/* Main container end */}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          {isLoading && <Loader />}
          {screenType == "web" ? (
            <Box w="100%">
              <Flex>
                <Box w="6rem">
                  <MiniSideBar />
                </Box>
                <Box w="100%">
                  <SecondaryNav customHeader="Visits" />

                  {/* Main container start */}
                  <Flex w="calc(100vw - 6rem)">
                    <Box
                      // p="1.5rem 8.25rem"
                      display="flex"
                      h="calc(100vh - 4rem)"
                      // h="100vh"
                      overflow="hidden auto"
                      overflowY={"hidden"}
                      w="100%"
                    >
                      {/* Left area start */}

                      <Box
                        w="23rem"
                        h="calc(100vh - 6rem)"
                        borderRight="1px solid #E6E7E9"
                      >
                        <Box
                          p="1.5rem"
                          display="flex"
                          flexDir="column"
                          gap="1rem"
                        >
                          <SearchBar
                            passInputPlace="Search"
                            onChange={(event) => setSearch(event.target.value)}
                          />
                          <TabSection
                            tabs={["Upcoming", "Past"]}
                            onClickTab={handleTabClick}
                            defaultIndex={selectedTabIndex}
                          />
                        </Box>

                        <Box
                          bg="#f9f9fa"
                          h="calc(100vh - 13rem)"
                          overflow="hidden auto"
                          p="1.5rem"
                        >
                          {/* {selectedTabIndex === 0 && ( */}
                            // Render content for the "Upcoming" tab
                            <Box>
                              {enhanceAndSortAppointmentDetails(
                                upcomingAppointments
                              ).some((appointment) => appointment.today) && (
                                <Box>
                                  {/* <Text
                                    fontSize="0.75rem"
                                    mb="1rem"
                                    letterSpacing="0.1rem"
                                    fontWeight="600"
                                    textTransform="uppercase"
                                    color="#061027"
                                  >
                                    Today
                                  </Text> */}
                                  {/* Render patient cards for today */}
                                  <Box
                                    display="flex"
                                    flexDir="column"
                                    gap="1rem"
                                  >
                                    {enhanceAndSortAppointmentDetails(
                                      upcomingAppointments
                                    )
                                      .filter(
                                        (appointment) => appointment.today
                                      )
                                      .filter((appointment) =>
                                        appointment.patientname
                                          .toLowerCase()
                                          .includes(search.toLowerCase())
                                      )
                                      .map((appointment) => (
                                        <PatientVisitCard
                                          key={appointment.appointmentid}
                                          userImage={
                                            appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                          }
                                          userName={appointment.patientname}
                                          visitDate={appointment.visitDate}
                                          visitTime={appointment.visitTime}
                                          doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                          issue={appointment.chiefcomplaint}
                                          borderColor={appointment.color}
                                          bgColor={appointment.color}
                                          patientId={appointment.patientid}
                                          // fetchCalendarData={fetchCalendarData}
                                          // fetchSidePanelData={fetchSidePanelData}
                                          refreshPageContent={
                                            refreshPageContent
                                          }
                                          appointmentId={
                                            appointment.appointmentid
                                          }
                                          
                                          appointmentStatus={
                                            appointment.appointmentstatus
                                          }
                                          visitStatus={
                                            appointment.appointmentcurrentstatus
                                          }
                                          isAssign={appointment.isaasign}
                                          isAssignStatus={appointment.assignstatusname}
                                          prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                        />
                                      ))}
                                  </Box>
                                </Box>
                              )}
                              {enhanceAndSortAppointmentDetails(
                                upcomingAppointments
                              ).some((appointment) => appointment.tomorrow) && (
                                <Box>
                                  {/* <Text
                                    fontSize="0.75rem"
                                    my="1rem"
                                    letterSpacing="0.1rem"
                                    fontWeight="600"
                                    textTransform="uppercase"
                                    color="#061027"
                                  >
                                    Tomorrow
                                  </Text> */}
                                  {/* Render patient cards for tomorrow */}
                                  <Box
                                    display="flex"
                                    flexDir="column"
                                    gap="1rem"
                                  >
                                    {enhanceAndSortAppointmentDetails(
                                      upcomingAppointments
                                    )
                                      .filter(
                                        (appointment) => appointment.tomorrow
                                      )
                                      .filter((appointment) =>
                                        appointment.patientname
                                          .toLowerCase()
                                          .includes(search.toLowerCase())
                                      )
                                      .map((appointment) => (
                                        <PatientVisitCard
                                          key={appointment.appointmentid}
                                          userImage={
                                            appointment.patientimage ? 
                                            (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                            : '/assets/imgs/no-image.png'
                                          }
                                          userName={appointment.patientname}
                                          visitDate={appointment.visitDate}
                                          visitTime={appointment.visitTime}
                                          doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                          issue={appointment.chiefcomplaint}
                                          borderColor={appointment.color}
                                          bgColor={appointment.color}
                                          appointmentId={
                                            appointment.appointmentid
                                          }
                                          
                                          patientId={appointment.patientid}
                                          // fetchCalendarData={fetchCalendarData}
                                          // fetchSidePanelData={fetchSidePanelData}
                                          refreshPageContent={
                                            refreshPageContent
                                          }
                                          appointmentStatus={
                                            appointment.appointmentstatus
                                          }
                                          visitStatus={
                                            appointment.appointmentcurrentstatus
                                          }
                                          isAssign={appointment.isaasign}
                                          isAssignStatus={appointment.assignstatusname}
                                          prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                        />
                                      ))}
                                  </Box>
                                </Box>
                              )}
                              {/* Render patient cards for this month */}
                              <Box>
                                {/* <Text
                                  fontSize="0.75rem"
                                  my="1rem"
                                  letterSpacing="0.1rem"
                                  fontWeight="600"
                                  textTransform="uppercase"
                                  color="#061027"
                                >
                                  This Month
                                </Text> */}
                                <Box display="flex" flexDir="column" gap="1rem">
                                  {enhanceAndSortAppointmentDetails(
                                    upcomingAppointments
                                  )
                                    .filter(
                                      (appointment) =>
                                        !appointment.today &&
                                        !appointment.tomorrow
                                    )
                                    .filter((appointment) =>
                                      appointment.patientname
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                    )
                                    .map((appointment) => (
                                      <PatientVisitCard
                                        key={appointment.appointmentid}
                                        userImage={
                                          appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                        }
                                        userName={appointment.patientname}
                                        visitDate={appointment.visitDate}
                                        visitTime={appointment.visitTime}
                                        doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                        issue={appointment.chiefcomplaint}
                                        borderColor={appointment.color}
                                        bgColor={appointment.color}
                                        appointmentId={
                                          appointment.appointmentid
                                        }
                                        
                                        patientId={appointment.patientid}
                                        // fetchCalendarData={fetchCalendarData}
                                        // fetchSidePanelData={fetchSidePanelData}
                                        refreshPageContent={refreshPageContent}
                                        appointmentStatus={
                                          appointment.appointmentstatus
                                        }
                                        visitStatus={
                                          appointment.appointmentcurrentstatus
                                        }
                                        isAssign={appointment.isaasign}
                                        isAssignStatus={appointment.assignstatusname}
                                        prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                      />
                                    ))}
                                </Box>
                              </Box>
                            </Box>
                          {/* )} */}

                          {/* Render content for the "Completed" tab */}
                          {/* {selectedTabIndex === 1 && ( */}
                            <Box>
                              <Box>
                                {/* <Text
                              fontSize="0.75rem"
                              mb="1rem"
                              letterSpacing="0.1rem"
                              fontWeight="600"
                              textTransform="uppercase"
                              color="#061027"
                            >
                              Completed
                            </Text> */}
                                {/* Render completed patient cards */}
                                <Box display="flex" flexDir="column" gap="1rem">
                                  {enhanceAndSortAppointmentDetails(
                                    pastAppointments,
                                    true // reverse sort
                                  )
                                    .filter((appointment) =>
                                      appointment.patientname
                                        .toLowerCase()
                                        .includes(search.toLowerCase())
                                    )
                                    .map((appointment) => (
                                      <PatientVisitCard
                                        key={appointment.appointmentid}
                                        userImage={
                                          appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                        }
                                        userName={appointment.patientname}
                                        visitDate={appointment.visitDate}
                                        visitTime={appointment.visitTime}
                                        doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                        issue={appointment.chiefcomplaint}
                                        borderColor={appointment.color}
                                        bgColor={appointment.color}
                                        appointmentId={
                                          appointment.appointmentid
                                        }
                                        patientId={appointment.patientid}
                                        // fetchCalendarData={fetchCalendarData}
                                        // fetchSidePanelData={fetchSidePanelData}
                                        refreshPageContent={refreshPageContent}
                                        
                                        appointmentStatus={
                                          appointment.appointmentstatus
                                        }
                                        visitStatus={
                                          appointment.appointmentcurrentstatus
                                        }
                                        prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                      />
                                    ))}
                                </Box>
                              </Box>
                            </Box>
                          {/* )} */}
                        </Box>
                      </Box>

                      {/* Left area end */}

                      {/* Main container start */}

                      <Box w="85%" bg="#ffffff" pb="0" overflowX="auto">
                        <Calendar
                          eventsArray={calendarAppointments}
                          setCalendarStartDate={setCalendarStartDate}
                          setCalendarEndDate={setCalendarEndDate}
                          onCalendarTitleChange={handleCalendarTitleChange}
                          refreshPageContent={refreshPageContent}
                        />
                      </Box>
                      {/* Main container end */}
                    </Box>
                  </Flex>
                  {/* Main container end */}
                </Box>
              </Flex>
            </Box>
          ) : (
            //Mobile responsive
            <>
              <MobileNavbar />
              <MobileSecondaryNav header="Visits" handlebackarrow={false} />

              <Box w="100%" h="calc(100vh - 12rem)" overflow="hidden auto">
                {/* Calendar start */}
                <Box w="100%">
                  <Calendar
                    eventsArray={calendarAppointments}
                    setCalendarStartDate={setCalendarStartDate}
                    setCalendarEndDate={setCalendarEndDate}
                    onCalendarTitleChange={handleCalendarTitleChange}
                    refreshPageContent={refreshPageContent}
                  />
                </Box>

                {/* Past and Upcoming visits */}
                <Box w="100%">
                  <Box
                    p="1rem"
                    pt="2rem"
                    display="flex"
                    flexDir="column"
                    gap="1rem"
                  >
                    <SearchBar
                      passInputPlace="Search"
                      onChange={(event) => setSearch(event.target.value)}
                    />
                    <TabSection
                      tabs={["Upcoming", "Past"]}
                      onClickTab={handleTabClick}
                      defaultIndex={selectedTabIndex}
                    />
                  </Box>

                  <Box bg="#f9f9fa" overflow="hidden auto" p="1rem">
                    {selectedTabIndex === 0 && (
                      // Render content for the "Upcoming" tab
                      <Box>
                        {enhanceAndSortAppointmentDetails(
                          upcomingAppointments
                        ).some((appointment) => appointment.today) && (
                          <Box>
                            {/* <Text
                              fontSize="0.75rem"
                              mb="1rem"
                              letterSpacing="0.1rem"
                              fontWeight="600"
                              textTransform="uppercase"
                              color="#061027"
                            >
                              Today
                            </Text> */}
                            {/* Render patient cards for today */}
                            <Box display="flex" flexDir="column" gap="1rem">
                              {enhanceAndSortAppointmentDetails(
                                upcomingAppointments
                              )
                                .filter((appointment) => appointment.today)
                                .filter((appointment) =>
                                  appointment.patientname
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                                )
                                .map((appointment) => (
                                  <PatientVisitCard
                                    key={appointment.appointmentid}
                                    userImage={
                                      appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                    }
                                    userName={appointment.patientname}
                                    visitDate={appointment.visitDate}
                                    visitTime={appointment.visitTime}
                                    doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                    issue={appointment.chiefcomplaint}
                                    borderColor={appointment.color}
                                    bgColor={appointment.color}
                                    patientId={appointment.patientid}
                                    // fetchCalendarData={fetchCalendarData}
                                    // fetchSidePanelData={fetchSidePanelData}
                                    refreshPageContent={refreshPageContent}
                                    appointmentId={appointment.appointmentid}
                                    appointmentStatus={
                                      appointment.appointmentstatus
                                    }
                                    visitStatus={
                                      appointment.appointmentcurrentstatus
                                    }
                                    prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                  />
                                ))}
                            </Box>
                          </Box>
                        )}
                        {enhanceAndSortAppointmentDetails(
                          upcomingAppointments
                        ).some((appointment) => appointment.tomorrow) && (
                          <Box>
                            {/* <Text
                              fontSize="0.75rem"
                              my="1rem"
                              letterSpacing="0.1rem"
                              fontWeight="600"
                              textTransform="uppercase"
                              color="#061027"
                            >
                              Tomorrow
                            </Text> */}
                            {/* Render patient cards for tomorrow */}
                            <Box display="flex" flexDir="column" gap="1rem">
                              {enhanceAndSortAppointmentDetails(
                                upcomingAppointments
                              )
                                .filter((appointment) => appointment.tomorrow)
                                .filter((appointment) =>
                                  appointment.patientname
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                                )
                                .map((appointment) => (
                                  <PatientVisitCard
                                    key={appointment.appointmentid}
                                    userImage={
                                      appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                    }
                                    userName={appointment.patientname}
                                    visitDate={appointment.visitDate}
                                    visitTime={appointment.visitTime}
                                    doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                    issue={appointment.chiefcomplaint}
                                    borderColor={appointment.color}
                                    bgColor={appointment.color}
                                    appointmentId={appointment.appointmentid}
                                    patientId={appointment.patientid}
                                    // fetchCalendarData={fetchCalendarData}
                                    // fetchSidePanelData={fetchSidePanelData}
                                    refreshPageContent={refreshPageContent}
                                    appointmentStatus={
                                      appointment.appointmentstatus
                                    }
                                    visitStatus={
                                      appointment.appointmentcurrentstatus
                                    }
                                    prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                  />
                                ))}
                            </Box>
                          </Box>
                        )}
                        {/* Render patient cards for this month */}
                        <Box>
                          {/* <Text
                            fontSize="0.75rem"
                            my="1rem"
                            letterSpacing="0.1rem"
                            fontWeight="600"
                            textTransform="uppercase"
                            color="#061027"
                          >
                            This Month
                          </Text> */}
                          <Box display="flex" flexDir="column" gap="1rem">
                            {enhanceAndSortAppointmentDetails(
                              upcomingAppointments
                            )
                              .filter(
                                (appointment) =>
                                  !appointment.today && !appointment.tomorrow
                              )
                              .filter((appointment) =>
                                appointment.patientname
                                  .toLowerCase()
                                  .includes(search.toLowerCase())
                              )
                              .map((appointment) => (
                                <PatientVisitCard
                                  key={appointment.appointmentid}
                                  userImage={
                                    appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                  }
                                  userName={appointment.patientname}
                                  visitDate={appointment.visitDate}
                                  visitTime={appointment.visitTime}
                                  doctorName={appointment.doctorname}
                                  patientFcm={appointment.fcmtoken}
                                  issue={appointment.chiefcomplaint}
                                  borderColor={appointment.color}
                                  bgColor={appointment.color}
                                  appointmentId={appointment.appointmentid}
                                  patientId={appointment.patientid}
                                  // fetchCalendarData={fetchCalendarData}
                                  // fetchSidePanelData={fetchSidePanelData}
                                  refreshPageContent={refreshPageContent}
                                  appointmentStatus={
                                    appointment.appointmentstatus
                                  }
                                  visitStatus={
                                    appointment.appointmentcurrentstatus
                                  }
                                  prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                />
                              ))}
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {/* Render content for the "Completed" tab */}
                    {selectedTabIndex === 1 && (
                      <Box>
                        <Box>
                          {/* <Text
                        fontSize="0.75rem"
                        mb="1rem"
                        letterSpacing="0.1rem"
                        fontWeight="600"
                        textTransform="uppercase"
                        color="#061027"
                      >
                        Completed
                      </Text> */}
                          {/* Render completed patient cards */}
                          <Box display="flex" flexDir="column" gap="1rem">
                            {enhanceAndSortAppointmentDetails(
                              pastAppointments,
                              true // reverse sort
                            )
                              .filter((appointment) =>
                                appointment.patientname
                                  .toLowerCase()
                                  .includes(search.toLowerCase())
                              )
                              .map((appointment) => (
                                <PatientVisitCard
                                  key={appointment.appointmentid}
                                  userImage={
                                    appointment.patientimage ? 
                                (appointment.patientimage.startsWith('https') ? appointment.patientimage : appointment.imagepath + appointment.patientimage) 
                                : '/assets/imgs/no-image.png'
                                  }
                                  userName={appointment.patientname}
                                  visitDate={appointment.visitDate}
                                  visitTime={appointment.visitTime}
                                  doctorName={appointment.doctorname}
                                        patientFcm={appointment.fcmtoken}
                                  issue={appointment.chiefcomplaint}
                                  borderColor={appointment.color}
                                  bgColor={appointment.color}
                                  appointmentId={appointment.appointmentid}
                                  patientId={appointment.patientid}
                                  // fetchCalendarData={fetchCalendarData}
                                  // fetchSidePanelData={fetchSidePanelData}
                                  refreshPageContent={refreshPageContent}
                                  appointmentStatus={
                                    appointment.appointmentstatus
                                  }
                                  visitStatus={
                                    appointment.appointmentcurrentstatus
                                  }
                                  prescriptionUrl={appointment.prescriptionurl}
                                      imagePath={appointment.imagepath}
                                />
                              ))}
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </>
      )}
    </>
  );
};

export default VisitsIndex;
